import { Outlet } from "react-router-dom";
import TrainForm from "./TrainForm";
import TrainList from "./TrainList";

export const adminTrainsRoutes = [
  {
    path: "trains",
    element: Outlet,
    children: [
      {
        path: "",
        element: TrainList,
      },
      {
        path: "list",
        element: TrainList,
      },
      {
        path: "add",
        element: TrainForm,
      },
      {
        path: "edit/:id",
        element: TrainForm,
      },
    ],
  },
];
